import * as React from "react";
import LinkJuiceCategorySection from "./LinkJuiceCategorySection";
import { LinkJuiceProps } from "./typings";

export function LinkJuice(props: LinkJuiceProps) {
  const { flexComponent, isInsideTabGroup } = props;
  const model = flexComponent && flexComponent.model;
  const title = model && model.title;
  const categories = model && model.categories;

  if (!(title && categories && categories.length)) {
    return null;
  }

  const paddingTopClassName = isInsideTabGroup ? "" : " all-t-padding-three";

  return (
    <div
      className={`LinkJuice all-cell-1-1 uitk-cell${paddingTopClassName}`}
      id={flexComponent.id}
      data-fm={flexComponent.fmId}
      data-fm-title-id={flexComponent.fmTitleId}
    >
      {!isInsideTabGroup && <h2 className="uitk-type-heading-600">{title}</h2>}
      {categories.map(
        category =>
          category.name && <LinkJuiceCategorySection key={category.name} category={category} />
      )}
    </div>
  );
}

export default LinkJuice;
